import { objToUrlParams } from '@/utils'
import request from '@/utils/request'

export const getAntRegisterList = (params: any) =>
  request({
    url: '/manage/ant-register-task',
    method: 'get',
    params
  })

export const setAntRegisterReview = (data: any) =>
  request({
    url: '/manage/ant-register-task/' + data.id,
    method: 'put',
    data
  })
